// @flow
import Loadable from 'react-loadable'

import Loader from '@src/components/ui/ReactLoadableLoader'

const Error500Loader = Loadable({
  loader: () => import('./Error500'),
  loading: Loader,
})

export default Error500Loader
